
import { mapState } from 'vuex';

export default {
  name: 'AppResourceKeywords',
  props: {
    tagLabels: { type: Array, required: true },
    layout: {
      type: String,
      default: 'flex',
      validator: v => ['flex', 'block'].includes(v)
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    tagStyle() {
      return {
        '--background-color': this.reviewSettings
          .review_keyword_background_color,
        '--color': this.reviewSettings.review_keyword_text_color
      };
    }
  }
};
